module.exports = __webpack_public_path__ + "img/NZA Annex M - Capital mobilization.pdf";